import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { ALL_FLAVOURS, FLAVOUR_TITLES } from 'constants/flavours'
import { QA_MENU } from 'constants/controllers'
import { setQAKeyword, setQAShowFavouritesOnly } from 'redux/actions/qa'
import TiledMenuHeader from 'components/tiled-menu/Header'
import FlavourSelector from 'components/shared/FlavourSelector'
import FlavourIcon from 'components/shared/FlavourIcon'

export default function QaMenuHeader () {
  const dispatch = useDispatch()

  const keyword = useSelector(state => state.qa.keyword || '')
  const showFavouritesOnly = useSelector(state => state.qa.showFavouritesOnly || false)
  const [selectedAols, setSelectedAols] = React.useState([])

  const setKeyword = (val) => {
    dispatch(setQAKeyword(val))
  }

  const setShowFavouritesOnly = (newValue) => {
    dispatch(setQAShowFavouritesOnly(newValue))
  }

  return (
    <TiledMenuHeader
      title='Q&A'
      keyword={keyword}
      setKeyword={setKeyword}
      showFavouritesOnly={showFavouritesOnly}
      setShowFavouritesOnly={setShowFavouritesOnly}
      selectedAols={selectedAols}
      setSelectedAols={setSelectedAols}
    >
      <FlavourSelector
        options={
          ALL_FLAVOURS.map(flavour => ({
            label: (
              <div className='flex items-center gap5'>
                <FlavourIcon flavour={flavour} bw />
                {FLAVOUR_TITLES[flavour]}
              </div>
            ),
            href: url(QA_MENU, { flavour }),
            selected: false
          }))
        }
      />
    </TiledMenuHeader>
  )
}
